module.exports = __webpack_public_path__ + "static/media/vehicle-damage-search-bg.807ca0ad.svg";